export default "__VITE_ASSET__BzBdacQQ__"